import { render } from "./KebabItem.vue?vue&type=template&id=9929c124"
import script from "./KebabItem.vue?vue&type=script&lang=js"
export * from "./KebabItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__